import { useRenderNotifier, useDialog } from '@wui/common-library'
import { useIM } from '@wui/im'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import { TerminalChoiceModal, useStoreSettingsTerminals, OutgoingCallsHandlingConditions } from '@/entities/user-terminal'

import { useLocalization } from '@/shared/composables/localization'

import { resolveTerminalCallTarget } from '../lib/resolve-terminal-call-target'

export const LS_KEY = 'wc-dont-show-anymore-terminal-notification'

export const isHiddenTerminalUseNotification = ref(localStorage.getItem(LS_KEY) ?? false)

export const WEB_CLIENT_TERMINAL_ID = 10

export const hideTerminalUseNotification = (dontShowAnymore: boolean) => {
  isHiddenTerminalUseNotification.value = true

  if (dontShowAnymore) {
    localStorage.setItem(LS_KEY, 'true')
  }
}

export const showTerminalUseNotification = () => {
  isHiddenTerminalUseNotification.value = false

  localStorage.removeItem(LS_KEY)
}

export const callFromAnotherTerminalIfNeeded = async (to: string): Promise<boolean> => {
  const { showDialog } = useDialog()
  const { requestTerminalCall } = useIM()
  const storeTerminals = useStoreSettingsTerminals()
  const { connectedTerminals, outgoingCallsHandlingCondition, defaultTerminalId } = storeToRefs(storeTerminals)
  const { notifyError, notifyWarning } = useRenderNotifier()
  const { t } = useLocalization()

  try {
    await storeTerminals.fetchTerminals()

    if (connectedTerminals.value.length > 1) {
      let id
      if (outgoingCallsHandlingCondition.value === OutgoingCallsHandlingConditions.ASK) {
        id = await showDialog(TerminalChoiceModal, { hasOverlay: true })

        if (id === false) {
          return true
        }
      } else {
        const isDefaultTerminalConnected = !!connectedTerminals.value.find(t => t.id === defaultTerminalId.value)
        if (isDefaultTerminalConnected) {
          id = defaultTerminalId.value
        } else {
          notifyWarning(t('common.terminalIsNotConnectedError', { id: defaultTerminalId.value }))

          return false
        }
      }
      const typedId = +(id as string)
      if (to && +typedId !== WEB_CLIENT_TERMINAL_ID) {
        await requestTerminalCall({
          to: await resolveTerminalCallTarget(to),
          terminalId: id as number,
        })

        return true
      }
    }

    return false
  } catch (e) {
    console.error(e)

    notifyError(t('calls.errorOccurredWhileCalling'))

    return false
  }
}
